<template>
	<div class="install-app">
		<modal-box v-if="modalBox.open" @close="onModalBoxClose" header="Install App">
			<button @click="onInstall" class="btn btn-primary btn-round">INSTALL</button>
		</modal-box>
	</div>
</template>

<script>
export default {
	data () {
		return {
			deferredPrompt: null,
			modalBox: {
				open: false
			}
		}
	},
	watch: {
		deferredPrompt (value) {
			if (value && value.isTrusted)
				this.modalBox.open = true
			else
				this.modalBox.open = false
		}
	},
	methods: {
		onInstall () {
			this.addToHomeScreen()
		},
		onModalBoxClose () {
			this.modalBox.open = false
		},
		addToHomeScreen () {
			this.deferredPrompt.prompt()
			this.deferredPrompt.userChoice
				.then(result => {
					this.deferredPrompt = null
				})
		}
	},
	created () {
		window.addEventListener('beforeinstallprompt', (e) => {
			e.preventDefault()
			this.deferredPrompt = e
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/install/InstallApp.vue